// extracted by mini-css-extract-plugin
module.exports = {"iconaWrapper":"iconaMedia_iconaWrapper__aEGui"};